import  { useState } from 'react'
import { Footer } from '../../../components/footer';
import BuyTokenModal from '../../modals/buytoken';
import { useNavigate } from 'react-router-dom';
import { useStakeDetails, useStakeHistory } from './api';
import Loader from '../../Loader/buttonLoad';
import { Pagination, PaginationItem, PaginationLink } from 'reactstrap';
import moment from 'moment';

const StakingWallet = () => {
    const [buyTokenModal, setBuyTokenModal] = useState(false);
    const navigate = useNavigate()
    const { data: stakeBalance, isLoading } = useStakeDetails()

    const [page, setPage] = useState(0);
    const { data: stakeList, isFetching } = useStakeHistory({
        page,
        size: 10,
        search: ''
    })
    const totalPages = Math.ceil(stakeList?.count / 10);

    const handlePageChange = (newPage) => {
        if (newPage >= 0 && newPage < totalPages) {
            setPage(newPage);
        }
    };

    const stakeStatus = (i) => {
        return (!i.isRewardForYear5) ? " Active" : " Expired";
    };
    const stakePercentage = (i) => {
        if (!i.isRewardForYear1) {
            return i?.commissionForYear1
        } else if (!i.isRewardForYear2) {
            return i?.commissionForYear2
        } else if (!i.isRewardForYear3) {
            return i?.commissionForYear3
        } else if (!i.isRewardForYear4) {
            return i?.commissionForYear4
        } else {
            return i?.commissionForYear5
        }
    };

    const stakeDetails = async (id) => {
        navigate(`/staking-history/${id}`)
    }

    return (
        <>
            <div className="mainContent">
                {(isLoading || isFetching) && <Loader />}
                <div className="pageContent def-py-30">
                    <div className='container'>
                        <div className="appPagetitle"><button className='btn btnBack' onClick={() => navigate('/dashboard')}>
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M4.16699 10H15.8337" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M4.16699 10L7.50033 13.3333" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M4.16699 10.0003L7.50033 6.66699" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </button> Staking Wallet</div>
                        <div className='row'>
                            <div className="col-lg-12">
                                <div className="appcard mb-4 p-lg-4">
                                    <div className="row align-items-center">
                                        <div className="col-lg-3">
                                            <div className='d-flex g-15 align-items-center'>
                                                <div className='masterWalletIcon animate__animated animate__pulse animate__infinite'>
                                                    <img src={require('../../../assets/images/stakingwalletImg.svg').default} alt='stakingwalletImg' className='img-fluid animate__animated animate__pulse animate__infinite' />
                                                </div>
                                                <div className='rightLevelcnt'>
                                                    <div className='labelTxt'>Wallet Balance</div>
                                                    <div className='labelVal'>{(stakeBalance?.data?.stakeWalletAvailable)?.toString().includes('.') ? parseFloat(stakeBalance?.data?.stakeWalletAvailable)?.toFixed(5).replace(/(\.0+)?$/, '') : stakeBalance?.data?.stakeWalletAvailable} <span className='fs-14 fw-400 text-white-60'>TPL</span></div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-9">
                                            <div className="row rightLevelcnt">
                                                <div className="col-md col-sm-6 mb-3 mb-md-0">
                                                    <div>
                                                        <div className='labelTxt'>Active Stake</div>
                                                        
                                                        <div className='labelVal'>
                                                            {(() => {
                                                                const activeStake = stakeBalance?.data?.activeStake;
                                                                if (!activeStake || activeStake < 0) return 0;
                                                                return activeStake.toString().includes('.')
                                                                    ? parseFloat(activeStake).toFixed(5).replace(/(\.0+)?$/, '')
                                                                    : activeStake;
                                                            })()} {''}
                                                            <span className='fs-14 fw-400 text-white-60'>TPL</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md col-sm-6 mb-3 mb-md-0">
                                                    <div>
                                                        <div className='labelTxt'>Closed Stake</div>
                                                        
                                                        <div className='labelVal'>
                                                        {(() => {
                                                                const closedStake = stakeBalance?.data?.closedStake;
                                                                if (!closedStake || closedStake < 0) return 0;
                                                                return closedStake.toString().includes('.')
                                                                    ? parseFloat(closedStake).toFixed(5).replace(/(\.0+)?$/, '')
                                                                    : closedStake;
                                                            })()} {''}
                                                            
                                                            <span className='fs-14 fw-400 text-white-60'>TPL</span></div>
                                                    </div>
                                                </div>
                                                <div className="col-md col-sm-6 mb-3 mb-md-0">
                                                    <div>
                                                        <div className='labelTxt'>Stake Claim</div>
                                                        <div className='labelVal'>{(stakeBalance?.data?.totalStakeReward)?.toString().includes('.') ? parseFloat(stakeBalance?.data?.totalStakeReward)?.toFixed(5).replace(/(\.0+)?$/, '') : stakeBalance?.data?.totalStakeReward} <span className='fs-14 fw-400 text-white-60'>TPL</span></div>
                                                    </div>
                                                </div>
                                                <div className="col-md-auto col-sm-auto">
                                                    <button className='btn btn-primary px-4' onClick={() => navigate('/stakingwallet-history')}>History</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='card2Head'>Stake</div>
                                {stakeList?.data?.length > 0 ?
                                    stakeList?.data?.map((i) =>
                                        <div className="appcard mb-4 p-3" key={i}>
                                            <div className="row align-items-center rightLevelcnt">
                                                <div className="col-lg-auto col-md-auto">
                                                    <div className="appDarkCard mb-3 mb-md-0">
                                                        <div className="stakingwalletbx">
                                                            <div className='d-flex align-items-center justify-content-between mb-4'>
                                                                <div className='leftTxt'>Stake Amount</div>
                                                                <div className={stakeStatus(i) === " Active" ? 'activeStaus text-right' : 'inActiveStaus text-right'}><span></span>{stakeStatus(i)}</div>
                                                            </div>
                                                            <div className="text-center">
                                                                <div className='fs-26 fw-400'>{(i?.stakeAmount)?.toString().includes('.') ? parseFloat(i?.stakeAmount)?.toFixed(5).replace(/(\.0+)?$/, '') : i?.stakeAmount} TPL</div>
                                                                <div className='fs-14 fw-400'>{(i?.currUsdtValue)?.toString().includes('.') ? parseFloat(i?.currUsdtValue)?.toFixed(5).replace(/(\.0+)?$/, '') : i?.currUsdtValue} USDT</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-lg col-md">
                                                    <div className="row">
                                                        <div className="col-md-4 col-sm-6 mb-3 mb-md-0">
                                                            <div>
                                                                <div className='labelTxt'>Stake Id</div>
                                                                <div className='labelVal fs-18'>{i?.stakeId}</div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-4 col-sm-6 mb-3 mb-md-0">
                                                            <div>
                                                                <div className='labelTxt'>Yield Value</div>
                                                                <div className='labelVal fs-18'>{stakePercentage(i)}%</div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-4 ">
                                                            <div>
                                                                <div className='labelTxt'>Reward Earned</div>
                                                                <div className='labelVal fs-18'>{(i?.rewardAmount)?.toString().includes('.') ? parseFloat(i?.rewardAmount)?.toFixed(5).replace(/(\.0+)?$/, '') : i?.rewardAmount}  <span className='smTxt'>TPL</span></div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <hr className='cusHr' />
                                                    <div className="row rightLevelcnt">
                                                        <div className="col-md-4 col-sm-6 mb-3 mb-md-0">
                                                            <div>
                                                                <div className='labelTxt'>Start Date & Time</div>
                                                                <div className='labelVal fs-18'>{moment(i.createdAt).format("DD/MM/YYYY | hh:mm A")}</div>


                                                            </div>
                                                        </div>
                                                        <div className="col-md-4 col-sm-6 mb-3 mb-md-0">
                                                            <div>
                                                                <div className='labelTxt'>End Date & Time</div>
                                                                <div className='labelVal fs-18'>{(i.slotNumber > 0 && !stakeList.checkSlotclaimed) ? '---' : moment(i.endDate).format("DD/MM/YYYY | hh:mm A")}</div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-4 ">
                                                            <div>
                                                                <div className='labelTxt'>Stake Type</div>
                                                                <div className='labelVal fs-18'> {(i.slotNumber > 0 && !stakeList.checkSlotclaimed) ? 'Unlimited' : 'Limited'}</div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                                <div className='col-lg-auto text-right mt-3 mt-lg-0'>
                                                    <button className='btn btn-secondary btnview' onClick={() => stakeDetails(i?.stakeId)}>View</button>
                                                </div>
                                            </div>
                                        </div>) : (
                                        <tr>
                                            <td colSpan="5" className="text-center">No data found</td>
                                        </tr>
                                    )

                                }
                                <div className="px-4">
                                    <div className='row'>
                                        <div className='col-lg-12'>
                                            <Pagination aria-label="Page navigation" className='customPagination'>
                                                <PaginationItem disabled={page === 0}>
                                                    <PaginationLink previous href="#" onClick={() => handlePageChange(page - 1)} className='prevbtn'>
                                                        <i className='bi bi-arrow-left align-bottom'></i> Previous
                                                    </PaginationLink>
                                                </PaginationItem>
                                                <span className='number'>

                                                    {page < 3 ? (
                                                        // Show first three pages if the current page is less than 3
                                                        Array.from({ length: Math.min(3, totalPages) }, (_, index) => (
                                                            <PaginationItem key={index} active={index === page} className={`${index === page ? 'customPagination active' : 'customPagination'}`}>
                                                                <PaginationLink href="#" onClick={() => handlePageChange(index)}>
                                                                    {index + 1}
                                                                </PaginationLink>
                                                            </PaginationItem>
                                                        ))
                                                    ) : (
                                                        // Show a dynamic range around the current page if the current page is 3 or greater
                                                        <>
                                                            {page > 0 && (
                                                                <PaginationItem key={0} className="customPagination">
                                                                    <PaginationLink href="#" onClick={() => handlePageChange(0)}>
                                                                        1
                                                                    </PaginationLink>
                                                                </PaginationItem>
                                                            )}

                                                            {page > 1 && (
                                                                <PaginationItem disabled>
                                                                    <PaginationLink href="#">...</PaginationLink>
                                                                </PaginationItem>
                                                            )}

                                                            {Array.from({ length: 3 }, (_, index) => (
                                                                <PaginationItem key={page - 1 + index} active={page - 1 + index === page} className={`${page - 1 + index === page ? 'customPagination active' : 'customPagination'}`}>
                                                                    <PaginationLink href="#" onClick={() => handlePageChange(page - 1 + index)}>
                                                                        {page - 1 + index + 1}
                                                                    </PaginationLink>
                                                                </PaginationItem>
                                                            ))}

                                                            {page < totalPages - 2 && (
                                                                <PaginationItem disabled>
                                                                    <PaginationLink href="#">...</PaginationLink>
                                                                </PaginationItem>
                                                            )}

                                                            {page < totalPages - 1 && (
                                                                <PaginationItem key={totalPages - 1} className="customPagination">
                                                                    <PaginationLink href="#" onClick={() => handlePageChange(totalPages - 1)}>
                                                                        {totalPages}
                                                                    </PaginationLink>
                                                                </PaginationItem>
                                                            )}
                                                        </>
                                                    )}
                                                </span>

                                                <PaginationItem disabled={page === totalPages - 1}>
                                                    <PaginationLink next href="#" onClick={() => handlePageChange(page + 1)} className='nextbtn'>
                                                        Next <i className='bi bi-arrow-right align-bottom'></i>
                                                    </PaginationLink>
                                                </PaginationItem>
                                            </Pagination>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <Footer />
            <BuyTokenModal modalOpen={buyTokenModal} modalClose={() => setBuyTokenModal(!buyTokenModal)} />
        </>
    )
}

export default StakingWallet;